module.exports = __webpack_public_path__ + "img/cancun.ac517cc3.jpg";